import useAuth from 'hooks/useAuth';
import useClinicDocuments from 'hooks/useClinicDocuments';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import MainCard from 'views/components/cards/MainCard';
import ManageFolders from 'views/components/clinic-documents/ManageFolders';
import NewFolder from 'views/components/clinic-documents/NewFolder';

const ClinicDocuments = () => {
  const intl = useIntl();
  const { userId } = useAuth();

  const { documents, refetchDocuments } = useClinicDocuments();

  const [creatingFolder, setCreatingFolder] = useState(false);
  const [editingFolderId, setEditingFolderId] = useState<undefined | string>();

  return (
    <MainCard title={intl.formatMessage({ defaultMessage: 'Clinic Documents' })} sx={{ minHeight: 400 }}>
      <ManageFolders openNewFolderDialog={() => setCreatingFolder(true)} setEditingFolderId={setEditingFolderId} selectOnly={false} />

      {(creatingFolder || !!editingFolderId) && (
        <NewFolder
          editingFolderId={editingFolderId}
          onClose={() => {
            setCreatingFolder(false);
            setEditingFolderId(undefined);
            refetchDocuments();
          }}
        />
      )}
    </MainCard>
  );
};

export default ClinicDocuments;
